'use strict';

/**
 * Changes from base:
 * 1. Added logic to load Promotions and select2 on focusQuickview.
 * 2. Added custom cart validation to updateAddToCart.
 * 3. Added add to cart listener on updateAddToCart.
 */

var base = require('base/product/base');
var baseCustom = require('./base');
var quickView = require('base/product/quickView');
var focusHelper = require('base/components/focus');
var promotion = require('./promotion');
var addToCart = require('./addToCart');

quickView.updateAddToCart = function () {
    $('body').on('product:updateAddToCart', function (e, response) {
        // Update Add to Cart button availability data attributes
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global', response.$productContainer).attr(
            'data-readytoorder',
            response.product.readyToOrder
        );
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global', response.$productContainer).attr(
            'data-available',
            response.product.available
        );

        addToCart.enableAddToCartButton();
    });
};

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="quickViewModal" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <a class="full-pdp-link" href="" aria-label="View Product Details"></a>' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('#quickViewModal .modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            $('body').trigger('product:renderPromotionMessage');

            // Add Listener to Consent input
            addToCart.consentListener();
            $('body').trigger('product:renderAddToCartValidation');
            $.initCustomSelects();

            // Render the select2
            setTimeout(function () {
                $.initCustomSelects();
            }, 250);

            // Trigger the add to cart validations to enable or disable the button
            $('body').trigger('product:renderAddToCartValidation');

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    addToCart: baseCustom.addToCart,
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();

            // Render the promotions
            promotion.renderPromotionMessage();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function (e, data) {
            if (data && data.error) return;
            $('#quickViewModal').modal('hide');
        });
    },
    /**
     * After add-to-cart from quickview, refresh the quickview quantity dropdown before
     * the modal closes — catches edge cases where the modal stays open (e.g. error recovery).
     * On normal add-to-cart success the modal hides, making this a no-op in practice.
     */
    refreshQuantityAfterAddToCart: function () {
        $('body').on('product:afterAddToCart', function (e, data) {
            if (data && data.error) return;

            var $modal = $('#quickViewModal.show');
            if (!$modal.length) return;

            var $productContainer = $modal.find('.product-quickview');
            var $quantitySelect = $productContainer.find('.quantity-select');
            if (!$quantitySelect.length) return;

            var refreshUrl = $quantitySelect.find('option:first').data('url');
            if (!refreshUrl) return;

            $.ajax({
                url: refreshUrl,
                method: 'GET',
                success: function (response) {
                    if (!response.product) return;

                    var quantities = response.product.quantities || [];
                    $quantitySelect.empty();
                    quantities.forEach(function (q) {
                        var $option = $('<option>', { value: q.value, selected: q.selected })
                            .attr('data-url', q.url).text(q.value);
                        $quantitySelect.append($option);
                    });

                    if (!quantities.length) {
                        $productContainer.find('.attribute.quantity').hide();
                        $productContainer.find('.select2-container').hide();
                        $productContainer.find('button.add-to-cart, button.add-to-cart-global')
                            .prop('disabled', true)
                            .attr('data-available', 'false');
                        var $availability = $productContainer.find('.global-availability');
                        $availability.data('available', false).attr('data-available', 'false');
                        var notAvailableMsg = $availability.data('not-available-msg') || 'Sem stock';
                        $productContainer.find('.availability-msg').html('<div>' + notAvailableMsg + '</div>');
                    }
                }
            });
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('#quickViewModal.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('#quickViewModal.modal.show .product-quickview>.bundle-items').length) {
                $('#quickViewModal.modal.show').find(response.container).data('pid', response.data.product.id);
                $('#quickViewModal.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('#quickViewModal.modal.show .product-quickview').data('pid', response.data.product.id);
                $('#quickViewModal.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            }

            // Render promotions
            promotion.renderPromotionMessage();
        });
    },
    updateAddToCart: quickView.updateAddToCart,
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            var dialog = $(response.$productContainer).closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog)
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability', dialog)
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.add-to-cart-global', dialog).attr('data-readytoorder', allReady).attr('data-available', allAvailable);
                $('.global-availability .availability-msg', dialog)
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
};
